module.exports = __webpack_public_path__ + "static/img/GettyImages-931007142_a.87f6092.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/GettyImages-931007142_a.jpg
// module id = /AF8
// module chunks = 0